module.exports = __webpack_public_path__ + "static/media/Letter.f148040b.svg";